import { Form, Button, Flex } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useFields } from '../fields/fields';
import { useGenerateFormItem } from '../../../utils/generateFormItem';

export const InfosStep = ({
  form,
  infosStep,
  setInfosStep,
  setCurrent,
  supervision,
  setOpen,
  questionnaireType,
  setQuestionnaireType,
  setRatingDate,
  showReviewDrawer,
  supervisions,
  setSupervision
}) => {
  const { t } = useTranslation();
  const { infosSupervisionFields } = useFields({
    supervision,
    setQuestionnaireType,
    questionnaireType,
    setRatingDate,
    showReviewDrawer,
    supervisions,
    setSupervision
  });

  const generateFormItem = useGenerateFormItem();

  const handleFinish = (data) => {
    setCurrent((current) => current + 1);
    setInfosStep({ ...infosStep, ...data });
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish}>
      {infosSupervisionFields.map((field) =>
        generateFormItem('owners.users_shows.review_drawer', field)
      )}
      <Flex gap="small" justify="flex-end">
        <Button type="link" onClick={() => setOpen(false)}>
          {t('buttons.cancel')}
        </Button>
        <Button type="primary" htmlType="submit">
          {t('buttons.next')}
        </Button>
      </Flex>
    </Form>
  );
};

InfosStep.propTypes = {
  form: PropTypes.shape({}).isRequired,
  infosStep: PropTypes.shape({}),
  setInfosStep: PropTypes.func,
  setCurrent: PropTypes.func,
  supervision: PropTypes.shape({}),
  setOpen: PropTypes.func,
  setRatingDate: PropTypes.func,
  showReviewDrawer: PropTypes.bool,
  supervisions: PropTypes.arrayOf(PropTypes.shape({})),
  setSupervision: PropTypes.func,
  questionnaireType: PropTypes.string,
  setQuestionnaireType: PropTypes.func
};

InfosStep.defaultProps = {
  showReviewDrawer: false,
  infosStep: {},
  setInfosStep: () => {},
  setCurrent: () => {},
  setSupervision: () => {},
  setRatingDate: () => {},
  supervisions: [],
  supervision: {},
  setOpen: () => {},
  questionnaireType: '',
  setQuestionnaireType: () => {}
};
